import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ActionsGroup = styled.div({
	display: 'flex',
	alignItems: 'center',
	/* stylelint-disable property-no-unknown */
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	'> *': (props: { spacing: string }) => ({
		marginLeft: props.spacing === 'wide' ? token('space.200', '16px') : token('space.100', '8px'),
	}),
});
